import {apiCall} from '../actions/api'
import {setNotification} from 'state/actions'

const LOADED = 'app/texts/LOADED'

export default (state = {}, action = {}) => {
	switch (action.type) {
		case LOADED: {
			const {id, text} = action
			return {
				...state,
				[id]: text,
			}
		}
		default:
			return state
	}
}

export const getText = (id) => (dispatch) =>
	dispatch(apiCall(`/api/getText/${id}`))
	.then((text) => {dispatch({type: LOADED, id, text})})
	.catch(() => dispatch(setNotification(`Text ${id} could not be fetched.`, 'error')))



// WEBPACK FOOTER //
// ./state/ducks/text.js